var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 1V9H28",
    fill: "#264382"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28 13V9L20 1H4V13",
    stroke: "#264382",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 27V31H28V27",
    stroke: "#264382",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.143 19.1049C13.143 19.7429 12.955 20.2359 12.579 20.5839C12.203 20.9319 11.668 21.1049 10.975 21.1049H10.541V22.9999H8.99805V17.2889H10.975C11.696 17.2889 12.238 17.4459 12.6 17.7619C12.962 18.0779 13.143 18.5239 13.143 19.1049ZM10.541 19.8479H10.822C11.054 19.8479 11.238 19.7829 11.375 19.6529C11.512 19.5229 11.58 19.3429 11.58 19.1139C11.58 18.7279 11.367 18.5359 10.939 18.5359H10.541V19.8479Z",
    fill: "#86C2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8998 20.0229C18.8998 20.9759 18.6378 21.7109 18.1128 22.2259C17.5878 22.7409 16.8508 22.9999 15.8998 22.9999H14.0518V17.2889H16.0288C16.9458 17.2889 17.6538 17.5229 18.1518 17.9919C18.6498 18.4609 18.8998 19.1379 18.8998 20.0229ZM17.2988 20.0779C17.2988 19.5549 17.1948 19.1669 16.9878 18.9139C16.7808 18.6609 16.4668 18.5349 16.0448 18.5349H15.5958V21.7339H15.9398C16.4088 21.7339 16.7518 21.5979 16.9708 21.3259C17.1898 21.0539 17.2988 20.6379 17.2988 20.0779Z",
    fill: "#86C2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4429 22.9999H19.9229V17.2889H23.2979V18.5269H21.4429V19.6169H23.1539V20.8549H21.4429V22.9999Z",
    fill: "#86C2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 13H1V27H31V13Z",
    stroke: "#264382",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: -19,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.262745 0 0 0 0 0.509804 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1f42ddbeb24dada36b220d772b35572c.svg";
export { ForwardRef as ReactComponent };